var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Spinner',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.loadingMessage||"Loading ..."))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }